module.exports = __webpack_public_path__ + "static/img/IMG_20151122_215344.c7c4442b.jpg";